import {CommonActions} from '@react-navigation/native';
import {notificationService} from './notificationService';

let navigationRef: any = null;

/**
 * Set the navigation reference for global navigation
 */
export const setNavigationRef = (ref: any) => {
  navigationRef = ref;
};

/**
 * Handle 401 Unauthorized error by logging out and redirecting to login
 * Uses lazy loading to avoid circular dependency with ServiceContainer
 */
export const handleUnauthorizedError = async () => {
  try {
    // Lazy load ServiceContainer to break circular dependency
    const {ServiceContainer} = await import('../di/ServiceContainer');
    const authService = ServiceContainer.getInstance().getAuthService();
    
    // Logout user (clears storage)
    await authService.logout();

    // Navigate to login screen using CommonActions
    if (navigationRef && navigationRef.isReady()) {
      navigationRef.dispatch(
        CommonActions.reset({
          index: 0,
          routes: [{name: 'Login'}],
        }),
      );
    }

    // Show notification to user after a small delay to ensure navigation completed
    setTimeout(() => {
      notificationService.warning(
        'Tu sesión ha expirado. Por favor inicia sesión nuevamente.'
      );
    }, 300);
  } catch (error) {
    console.error('Error handling unauthorized:', error);
    // Still try to navigate to login even if logout fails
    if (navigationRef && navigationRef.isReady()) {
      navigationRef.dispatch(
        CommonActions.reset({
          index: 0,
          routes: [{name: 'Login'}],
        }),
      );
    }
  }
};

